export default __webpack_public_path__ + "static/media/cp_geo_ge.8e5d60ae.svg";